import script from "./PaymentMethodDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodDefault.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodDefault.vue?vue&type=style&index=0&id=c36dac12&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36dac12"]])

export default __exports__